import { EnumCustomerApplicationStatus } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';

export const getCustomerApplicationStatusDisplayValue = (
  value: number | undefined,
  translateFunc: (key: string) => string
) => {
  if (value === undefined || !EnumCustomerApplicationStatus[value]) return '';

  return translateFunc(`EnumCustomerApplicationStatus.${EnumCustomerApplicationStatus[value]}`);
};
